export const graph_data_xbo20 = {

      frequencyMin: 8,
      frequencyMax: 300,
      tempRanges: ["0..50ºC", "-10..60ºC", "-30..70ºC", "-40..85ºC", "-60..85ºC"], //update from tx product
      signalTypes: ["sWave3p3V", "sWave5V", "hcmos3p3V", "hcmos5V"], //update from tx product
        availableMultipliers: ["Fundamental", "x3", "x5"],
        data: {
          stability: {
              frequencyPoints: [8, 10, 20, 30, 50, 60, 100, 150, 200, 250],
              data: {
                "0..50ºC": {
                  "Fundamental": [0.3, 0.3, 0.6, 0.9, 1.5, 1.8, 3, 6, null, null],
                  "x3": [null, null, null, 0.3, 0.5, 0.6, 1, 1.5, 2, 2.5],
                  "x5": [null, null, null, null, 0.3, 0.4, 0.6, 0.9, 1.2, 1.5]
                },
                "-10..60ºC": {
                  "Fundamental": [0.3, 0.3, 0.6, 0.9, 1.5, 1.8, 3, 6, null, null],
                  "x3": [null, null, null, 0.3, 0.5, 0.6, 1, 1.5, 2, 2.5],
                  "x5": [null, null, null, null, 0.3, 0.4, 0.6, 0.9, 1.2, 1.5]
                },
                "-30..70ºC": {
                  "Fundamental": [0.5, 0.5, 1, 1.5, 2.5, 3, 5, 10, null, null],
                  "x3": [null, null, null, 0.5, 0.8, 1, 1.7, 2.5, 3.3, 4.2],
                  "x5": [null, null, null, null, 0.5, 0.6, 1, 1.5, 2, 2.5]
                },
                "-40..85ºC": {
                  "Fundamental": [0.5, 0.5, 1, 1.5, 2.5, 3, 5, 10, null, null],
                  "x3": [null, null, null, 0.5, 0.8, 1, 1.7, 2.5, 3.3, 4.2],
                  "x5": [null, null, null, null, 0.5, 0.6, 1, 1.5, 2, 2.5]
                },            
                "-60..85ºC": {
                  "Fundamental": [1, 1, 2, 3, 5, 6, 10, 20, null, null],
                  "x3": [null, null, null, 1, 1.7, 2, 3.3, 5, 6.7, 8.3],
                  "x5": [null, null, null, null, 1, 1.2, 2, 3, 4, 5]
                },  
            }
          },
          aging: {
            frequencyPoints: [10, 50, 150, 200, 250],
            data: {
              "0..50ºC": {
                  "Fundamental": [0.1, 1.5, 3, null, null],
                  "x3": [null, 0.5, 1.5, 2, 2],
                  "x5": [null, 0.1, 1, 1, 1.5],              
                },
                "-10..60ºC": {
                  "Fundamental": [0.1, 1.5, 3, null, null],
                  "x3": [null, 0.5, 1.5, 2, 2],
                  "x5": [null, 0.1, 1, 1, 1.5],     
                },
                "-30..70ºC": {
                  "Fundamental": [0.1, 1.5, 3, null, null],
                  "x3": [null, 0.5, 1.5, 2, 2],
                  "x5": [null, 0.1, 1, 1, 1.5],     
                },
                "-40..85ºC": {
                  "Fundamental": [0.2, 1.5, 3, null, null],
                  "x3": [null, 0.5, 1.5, 2, 2],
                  "x5": [null, 0.2, 1, 1, 1.5],     
                },
                "-60..85ºC": {
                  "Fundamental": [0.2, 1.5, 3, null, null],
                  "x3": [null, 0.5, 1.5, 2, 2],
                  "x5": [null, 0.2, 1, 1, 1.5],     
                }
            }
          },
          consumption: {
              frequencyPoints: [10, 50, 150, 200, 250],
              data: {
                  "0..50ºC": {
                    "sWave3p3V": {
                      "Fundamental": [73, 78, 90, null, null],
                              "x3": [null, 89, 105, 114, 122],
                              "x5": [null, 89, 105, 114, 122]  
                    },
                    "sWave5V": {
                      "Fundamental": [107, 118, 146, null, null],
                              "x3": [null, 143, 181, 200, 218],
                              "x5": [null, 143, 181, 200, 218]  
                    },
                    "hcmos3p3V": {
                      "Fundamental": [67, 70, 80, null, null],
                              "x3": [null, 79, 92, 99, 106],
                              "x5": [null, 79, 92, 99, 106]  
                    },
                    "hcmos5V": {
                      "Fundamental": [92, 101, 123, null, null],
                              "x3": [null, 120, 150, 165, 180],
                              "x5": [null, 120, 150, 165, 180]  
                    }
                  },
                  "-10..60ºC": {
                    "sWave3p3V": {
                      "Fundamental": [83, 88, 100, null, null],
                              "x3": [null, 99, 116, 124, 132],
                              "x5": [null, 99, 116, 124, 132]  
                    },
                    "sWave5V": {
                      "Fundamental": [117, 128, 156, null, null],
                              "x3": [null, 153, 191, 210, 229],
                              "x5": [null, 153, 191, 210, 229]  
                    },
                    "hcmos3p3V": {
                      "Fundamental": [77, 81, 91, null, null],
                              "x3": [null, 89, 103, 109, 116],
                              "x5": [null, 89, 103, 109, 116]  
                    },
                    "hcmos5V": {
                      "Fundamental": [102, 111, 133, null, null],
                              "x3": [null, 130, 160, 175, 190],
                              "x5": [null, 130, 160, 175, 190]  
                    }
                  },
                  "-30..70ºC": {
                    "sWave3p3V": {
                      "Fundamental": [99, 103, 116, null, null],
                              "x3": [null, 115, 131, 139, 147],
                              "x5": [null, 115, 131, 139, 147]  
                    },
                    "sWave5V": {
                      "Fundamental": [132, 143, 171, null, null],
                              "x3": [null, 169, 206, 225, 244],
                              "x5": [null, 169, 206, 225, 244]  
                    },
                    "hcmos3p3V": {
                      "Fundamental": [92, 96, 106, null, null],
                              "x3": [null, 104, 118, 124, 131],
                              "x5": [null, 104, 118, 124, 131]  
                    },
                    "hcmos5V": {
                      "Fundamental": [117, 126, 148, null, null],
                              "x3": [null, 145, 175, 190, 205],
                              "x5": [null, 145, 175, 190, 205]  
                    }
                  },
                  "-40..85ºC": {
                    "sWave3p3V": {
                      "Fundamental": [123, 128, 140, null, null],
                              "x3": [null, 139, 155, 163, 172],
                              "x5": [null, 139, 155, 163, 172]  
                    },
                    "sWave5V": {
                      "Fundamental": [156, 167, 195, null, null],
                              "x3": [null, 192, 230, 249, 268],
                              "x5": [null, 192, 230, 249, 268]  
                    },
                    "hcmos3p3V": {
                      "Fundamental": [116, 120, 130, null, null],
                              "x3": [null, 129, 142, 149, 155],
                              "x5": [null, 129, 142, 149, 155]  
                    },
                    "hcmos5V": {
                      "Fundamental": [141, 150, 172, null, null],
                              "x3": [null, 169, 199, 214, 229],
                              "x5": [null, 169, 199, 214, 229]  
                    }
                  },
                  "-60..85ºC": {
                    "sWave3p3V": {
                      "Fundamental": [123, 128, 140, null, null],
                              "x3": [null, 139, 155, 163, 172],
                              "x5": [null, 139, 155, 163, 172]  
                    },
                    "sWave5V": {
                      "Fundamental": [156, 167, 195, null, null],
                              "x3": [null, 192, 230, 249, 268],
                              "x5": [null, 192, 230, 249, 268]  
                    },
                    "hcmos3p3V": {
                      "Fundamental": [116, 120, 130, null, null],
                              "x3": [null, 129, 142, 149, 155],
                              "x5": [null, 129, 142, 149, 155]  
                    },
                    "hcmos5V": {
                      "Fundamental": [141, 150, 172, null, null],
                              "x3": [null, 169, 199, 214, 229],
                              "x5": [null, 169, 199, 214, 229]  
                    }
                }
              }
          }
        }
}